export default class ContactForm {
  constructor() {
    this.form = document.querySelector(".contact-form");
    this.submitButton = this.form.querySelector(".submit-button");
    this.files = new Map();
    this.formValidation = null;
    this.setupFormSteps();
    this.initializeValidations();
  }

  setupFormSteps() {
    const topicSelect = document.getElementById("input-topic");
    const step3Containers = document.querySelectorAll('[data-step="3"]');

    step3Containers.forEach(
      (container) => (container.style.visibility = "hidden"),
    );

    topicSelect?.addEventListener("change", () => {
      const visibility = topicSelect.value ? "visible" : "hidden";
      step3Containers.forEach(
        (container) => (container.style.visibility = visibility),
      );
    });
  }

  sendData(formData) {
    const config = window.BBDO_CONFIG || {};
    const url = config.contactEndpoint;
    const nonce = config.contactNonce;

    if (!url) {
      console.warn(
        "Trimiterea formularului este dezactivată până la configurarea BBDO_CONFIG.contactEndpoint.",
      );
      return Promise.resolve(null);
    }

    const body = new FormData();
    body.append("name", formData.fullName);
    body.append("email", formData.email);
    body.append("topic", formData.topic);
    body.append("message", formData.message);
    body.append("website", formData.website || "");

    if (formData.files && formData.files.length > 0) {
      formData.files.forEach((file) => {
        body.append("files", file);
      });
    }

    return fetch(url, {
      method: "POST",
      headers: nonce ? { "X-WP-Nonce": nonce } : {},
      body: body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        const successContainer = document.querySelector(
          "#contact-form__thanks",
        );
        const mainTitle = document.querySelector("#contact-title");
        const formContainer = document.querySelector("#contact-form");

        if (successContainer && formContainer) {
          formContainer.style.display = "none";
          successContainer.style.display = "flex";
          mainTitle.style.display = "none";
        }
      })
      .catch((error) => {
        console.error("Eroare:", error);
      });
  }

  handleFormSubmit() {
    const formData = {
      topic: document.getElementById("input-topic").value,
      fullName: document.getElementById("input-fullname").value,
      email: document.getElementById("input-email").value,
      message: document.getElementById("input-message").value,
      files: this.getFilesList(),
      website: document.getElementById("input-website")?.value || "",
    };

    this.sendData(formData);
  }

  getFilesList() {
    return Array.from(this.files.values());
  }

  initializeValidations() {
    const formValidate = new JustValidate(this.form, {
      validateBeforeSubmitting: true,
      testingMode: false,
    });

    formValidate.onValidate(() => {
      const isValid = formValidate.isValid;

      if (isValid) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove("button-disabled");
      } else {
        this.submitButton.disabled = true;
        this.submitButton.classList.add("button-disabled");
      }
    });

    formValidate.onSuccess((event) => {
      event?.preventDefault();
      this.handleFormSubmit();
    });

    formValidate
      .addField("#input-topic", [
        {
          rule: "required",
        },
      ])
      .addField("#input-fullname", [
        {
          rule: "required",
          errorMessage: "Acest câmp este obligatoriu.",
        },
        {
          rule: "minLength",
          value: 2,
          errorMessage: "Numele trebuie să aibă cel puțin 2 caractere.",
        },
        {
          rule: "maxLength",
          value: 50,
          errorMessage: "Numele nu poate avea mai mult de 50 de caractere.",
        },
        {
          rule: "customRegexp",
          value: /^[\p{L}\s'-]*$/u,
          errorMessage: "Acest câmp poate conține doar litere.",
        },
      ])
      .addField("#input-email", [
        {
          rule: "required",
          errorMessage: "Acest câmp este obligatoriu.",
        },
        {
          rule: "email",
          errorMessage: "Introdu o adresă de e-mail validă.",
        },
        {
          rule: "minLength",
          value: 3,
          errorMessage:
            "Adresa de e-mail trebuie să aibă cel puțin 3 caractere.",
        },
        {
          rule: "maxLength",
          value: 50,
          errorMessage:
            "Adresa de e-mail nu poate avea mai mult de 50 de caractere.",
        },
      ])
      .addField(
        "#input-message",
        [
          {
            rule: "required",
            errorMessage: "Acest câmp este obligatoriu.",
          },
          {
            rule: "minLength",
            value: 50,
            errorMessage: "Mesajul trebuie să aibă cel puțin 50 de caractere.",
          },
          {
            rule: "customRegexp",
            value: /^[\p{L}\s\d.,;:!?"'()–—-]*$/u,
            errorMessage: "Mesajul conține caractere nepermise.",
          },
        ],
        {
          errorsContainer: ".group-message",
        },
      )
      .addField("#input-files", [
        {
          validator: () => {
            const fileInput = document.getElementById("input-files");
            if (fileInput.files.length > 0) {
              const validExtensions = ["pdf", "docx", "xlsx", "pptx"];
              const maxSize = 5242880; // 5MB in bytes

              for (let file of fileInput.files) {
                const extension = file.name.split(".").pop().toLowerCase();
                if (!validExtensions.includes(extension)) {
                  return false;
                }
                if (file.size > maxSize) {
                  return false;
                }
              }
            }

            return true;
          },
          errorMessage:
            "Fișierele trebuie să fie PDF, DOCX, XLSX sau PPTX și să aibă cel mult 5 MB.",
        },
      ]);

    this.formValidation = formValidate;
  }
}

export const setFileDragDrop = (contactForm) => {
  if (!contactForm) {
    console.error("Este necesară o instanță ContactForm");
    return;
  }

  const uploadArea = document.getElementById("uploadArea");
  const defaultState = document.getElementById("defaultState");
  const activeState = document.getElementById("activeState");
  const addButton = activeState?.querySelector(".btn-add");

  if (!uploadArea || !defaultState || !activeState || !addButton) {
    console.error("Elementele obligatorii nu au fost găsite");
    return;
  }

  let files = [];

  const createFileElement = (file) => {
    const fileDiv = document.createElement("div");
    fileDiv.className = "input-dd-files__file";
    fileDiv.innerHTML = `
            <div class="input-dd-files__actions">
                <svg class="input-dd-files__icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16h12V9z" stroke="#FAFAFA" stroke-width="2"/>
                </svg>
                <span class="input-dd-files__filename">${file.name}</span>
                <button class="input-dd-files__button" data-filename="${file.name}">
                    <svg width="20" height="22" viewBox="0 0 20 22" fill="none">
                        <path d="M11.7225 10.2555V16.7555M7.38916 10.2555V16.7555M3.05583 5.9222V18.9222C3.05583 19.4968 3.2841 20.0479 3.69043 20.4543C4.09676 20.8606 4.64786 21.0889 5.22249 21.0889H13.8892C14.4638 21.0889 15.0149 20.8606 15.4212 20.4543C15.8276 20.0479 16.0558 19.4968 16.0558 18.9222V5.9222M0.88916 5.9222H18.2225M4.13916 5.9222L6.30583 1.58887H12.8058L14.9725 5.9222" stroke="#FAFAFA" stroke-width="1.73333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        `;

    activeState.insertBefore(fileDiv, addButton.nextSibling);

    fileDiv
      .querySelector(".input-dd-files__button")
      .addEventListener("click", (e) => {
        e.stopPropagation();
        const fileName = e.currentTarget.dataset.filename;
        files = files.filter((f) => f.name !== fileName);
        contactForm.files.delete(fileName);
        fileDiv.remove();
        updateDisplayState();
      });
  };

  const updateDisplayState = () => {
    if (files.length > 0) {
      uploadArea.classList.add("input-dd-files__area--active");
      defaultState.style.display = "none";
      activeState.style.display = "flex";
    } else {
      uploadArea.classList.remove("input-dd-files__area--active");
      defaultState.style.display = "flex";
      activeState.style.display = "none";
    }
  };

  contactForm.form?.addEventListener("bbdo:reset-files", () => {
    files = [];
    contactForm.files.clear();
    updateDisplayState();
  });

  const handleFiles = (newFiles) => {
    Array.from(newFiles).forEach((file) => {
      if (!files.some((f) => f.name === file.name)) {
        files.push(file);
        contactForm.files.set(file.name, file);
        createFileElement(file);
      }
    });
    updateDisplayState();

    const hiddenInput = document.getElementById("input-files");
    const dataTransfer = new DataTransfer();
    files.forEach((file) => dataTransfer.items.add(file));
    hiddenInput.files = dataTransfer.files;
    hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
  };

  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    uploadArea.addEventListener(eventName, preventDefaults, false);
  });

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  ["dragenter", "dragover"].forEach((eventName) => {
    uploadArea.addEventListener(eventName, highlight, false);
  });

  ["dragleave", "drop"].forEach((eventName) => {
    uploadArea.addEventListener(eventName, unhighlight, false);
  });

  function highlight() {
    uploadArea.classList.add("input-dd-files__area--dragover");
  }

  function unhighlight() {
    uploadArea.classList.remove("input-dd-files__area--dragover");
  }

  uploadArea.addEventListener("drop", handleDrop, false);

  uploadArea.addEventListener("click", () => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true; // Allow multiple files
    input.accept = ".pdf,.docx,.xlsx,.pptx";
    input.onchange = (e) => {
      handleFiles(e.target.files);
    };
    input.click();
  });

  function handleDrop(e) {
    const dt = e.dataTransfer;
    handleFiles(dt.files);
  }
};
